import * as yup from 'yup';

// Validations
export const noteValidationSchema = yup.object({
  subject: yup.string().required('Please enter subject'),
  description: yup.string().required('Please enter note'),
  isPrivate: yup.boolean().oneOf([true, false]).typeError('Must be a boolean'),
});
